'use client'

import { Suspense } from 'react'
import { usePageViewTracking } from '@/hooks/usePageViewTracking'
import { useAttributionCapture } from '@/hooks/useAttributionCapture'

function TrackingHooks() {
  usePageViewTracking()
  useAttributionCapture()
  return null
}

export function TrackingProvider({ children }: { children: React.ReactNode }) {
  return (
    <>
      <Suspense fallback={null}>
        <TrackingHooks />
      </Suspense>
      {children}
    </>
  )
}
